
import React from 'react';
import { cn } from '@/lib/utils';

interface StyledIconProps {
  icon: React.ReactNode;
  variant?: 'coral' | 'yellow' | 'plum';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const variantStyles = {
  coral: {
    icon: 'text-[#F4978E]',
    background: 'bg-[#F4978E]/10'
  },
  yellow: {
    icon: 'text-[#FFE28C]',
    background: 'bg-[#FFE28C]/10'
  },
  plum: {
    icon: 'text-[#6C4F77]',
    background: 'bg-[#6C4F77]/10'
  }
};

const sizeStyles = {
  sm: 'h-10 w-10 text-lg',
  md: 'h-16 w-16 text-2xl',
  lg: 'h-20 w-20 text-3xl'
};

const StyledIcon: React.FC<StyledIconProps> = ({
  icon,
  variant = 'plum',
  size = 'md',
  className
}) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-xl',
        variantStyles[variant].background,
        sizeStyles[size],
        'shadow-soft',
        'border border-white/15',
        className
      )}
    >
      <span className={cn(variantStyles[variant].icon)}>{icon}</span>
    </div>
  );
};

export default StyledIcon;
